<template>
  <div>
    <div
      v-if="!show"
      class="spinner-loader"
    >
      <sync-loader />
      <p>Loading ...</p>
    </div>
    <div v-if="show">
      <div class="columns">
        <div class="column is-2">
          <router-link
            :to="{name: 'ToolsNewsCreate', params: {user: user}}"
            class="button is-info"
          >
            Create News
          </router-link>
        </div>
      </div>
      <div class="columns">
        <div class="column is-12 is-flex flex-wrap">
          <article
            v-for="article in articles"
            class="card tools-news-card is-2"
          >
            <div class="card-image tools-card-image">
              <img :src="article.headerimage">
            </div>
            <div
              class="card-content"
              style="height: 115px;"
            >
              <h5 class="title is-5">
                {{ substring(article.title, 15) }}
              </h5>
              <p class="is-size-7">
                {{ substring(article.text, 40) }}
              </p>
            </div>
            <footer class="card-footer">
              <router-link
                :to="`/admin/ahl-news/${article.id}/edit`"
                class="card-footer-item"
              >
                Edit
              </router-link>
              <a
                class="card-footer-item"
                @click="toggleAlert(article.id)"
              >Delete</a>
            </footer>
          </article>
          <div
            v-if="alert"
            class="columns"
          >
            <div class="column is-12 text-center">
              <div class="box tools-box-modal">
                <p>Are you sure?</p>
                <button
                  class="button is-small is-info"
                  @click="deleteNews(deleteId)"
                >
                  Yes
                </button>
                <div
                  class="button is-small is-danger"
                  @click="toggleAlert('')"
                >
                  No
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'

  export default {
    name: 'ToolsNewsIndex',
    components: {
    },
    props: ['user', 'token'],
    data() {
      return {
        articles: '',
        show: false,
        alert: false,
        deleteId: ''
      }
    },
    created() {
      if (!this.user || !this.user.isHost) this.$router.push({name: 'FourZeroFour'})
    },
    mounted() {
      this.getNews()
    },
    methods: {
      getNews() {
        this.show = false
        this.$axios({
          method: 'POST',
          url: 'ahlnews/getlist',
          headers: {
            Authorization: '84cd7a9a97d4c1d8f6402f9389711560',
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          data: {
            token: this.token
          }
        })
          .then((res) => {
            this.articles = res.data
            this.show = true
          })
          .catch((error) => {
            this.$emit('message', {error: true, showDialog: true, message: error.response.data.message})
          })
      },
      substring(string, symbols) {
        if (!string) return
        return string.replace(/(<([^>]+)>)/ig, '').substring(0, symbols)
      },
      deleteNews(id) {
        this.show = false
        this.$axios({
          method: 'POST',
          url: `ahlnews/delete/${id}`,
          headers: {
            Authorization: '84cd7a9a97d4c1d8f6402f9389711560',
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          data: {
            token: this.token
          }
        })
          .then((res) => {
            this.articles = res.data
            this.getNews()
            this.alert = false
            this.show = true
          })
          .catch((error) => {
            this.$emit('message', {error: true, showDialog: true, message: error.response.data.message})
          })
      },
      toggleAlert(id) {
        this.deleteId = id
        this.alert = !this.alert
      }
    }
  }
</script>
